import React from "react";
import { useTranslation } from "react-i18next";
import { encode64 } from "node-forge/lib/util";
import { publicKeyFromPem } from "node-forge/lib/pki";
import services from "../../Redux/services/sessionService";

import cert from "./cert.json";
import Modal from "./customModal";
import SuccessIcon from "../../../static/images/success-message.svg";
import { Buffer } from "buffer";

export const formatNumber = (num, symbol = "₡") => {
  return `${symbol} ${num
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
};

export const unformatNumber = (num) => {
  return parseInt(num.replace(/\D/g, "").slice(0, -2), 10);
};

export const moduleAction = (roles, module, action) => {
  return roles[module] ? roles[module].actions.includes(action) : false;
};

export const getNumberApprovals = (modules, searchModule) => {
  var selectedModule = null;
  modules.map((module) => {
    if (module.module.code === searchModule) {
      selectedModule = module;
    }
  });

  return selectedModule === null ? 0 : selectedModule.numberOfApprovals;
};

export const identificationFormat = (idCard, type) => {
  switch (type) {
    case "BUSINESS":
      return `${idCard.substring(0, 1)}-${idCard.substring(
        1,
        4
      )}-${idCard.substring(4, 10)}`;
    case "PERSONAL":
      return `${idCard.substring(0, 1)}-${idCard.substring(
        1,
        5
      )}-${idCard.substring(5, 9)}`;
    case "DIMEX":
      return `${idCard.substring(0, 12)}`;
    default:
      return false;
  }
};

export const encryptPassword = (passStr, key) => {
  var rsaPublicKey = publicKeyFromPem(
    `-----BEGIN PUBLIC KEY-----${key}-----END PUBLIC KEY----- `
  );

  const utf8Str = unescape(encodeURIComponent(passStr));
  var encrypt = encode64(rsaPublicKey.encrypt(utf8Str, "RSA-OAEP"));

  return encrypt;
};

export const getFilters = (filters = []) => {
  var strFilter = "";

  filters.map((filter, idx) => {
    if (idx > 0) {
      strFilter = `${strFilter}%7C`;
    }

    strFilter = `${strFilter}${filter.property}/${filter.operator}/${filter.value}`;
  });

  return strFilter;
};

export const queryString = (filters = []) => {
  var queryString = "";

  filters.map((filter, idx) => {
    if (idx == 0) {
      queryString = `${filter.property}=${filter.value}`;
    } else {
      queryString = `${queryString}&${filter.property}=${filter.value}`;
    }
  });

  return queryString;
};

export const generateButton = ({
  group,
  value,
  label,
  handlerFnc,
  checked,
  className,
}) => {
  return (
    <div className={className}>
      <label>
        <input
          key={`${group}-${label}`}
          type="radio"
          checked={checked}
          name={group}
          value={value}
          onClick={handlerFnc}
          readOnly
        />
        <span>{label}</span>
      </label>
    </div>
  );
};

export const loadingHtml = (text = "") => {
  const message = services.getLanguage() === "en" ? "Loading" : "Cargando";
  return (
    <div className="modal-container loading">
      <div className="loader"></div>
      <p>{text !== "" ? text : `${message}....`}</p>
    </div>
  );
};

export const errorContainer = (title, message, buttons = null) => {
  return (
    <div className="modal-container">
      <div className="error">
        <h2 className="modal-title">{title}</h2>
      </div>
      <p className="message">{message}</p>
      {buttons !== null && (
        <div className="actions">
          {buttons.cancelBtn && (
            <a onClick={buttons.cancelBtn.action} className="continue-btn">
              {buttons.cancelBtn.text}
            </a>
          )}
          {buttons.continueBtn && (
            <a
              onClick={buttons.continueBtn.action}
              className="continue-btn active"
            >
              {buttons.continueBtn.text}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export const infoContainer = (title, message, buttons = null) => {
  return (
    <div className="modal-container">
      <div className="error">
        <h2 className="modal-title">{title}</h2>
      </div>
      <p className="message">{message}</p>
      {buttons !== null && (
        <div className="actions">
          {buttons.SelBtn && (
            <a onClick={buttons.SelBtn.action} className="continue-btn">
              {buttons.SelBtn.text}
            </a>
          )}
          {buttons.formBtn && (
            <a onClick={buttons.formBtn.action} className="continue-btn">
              {buttons.formBtn.text}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export const sucessInfoModal = (
  title,
  message,
  buttons = null,
  loading = false
) => {
  return (
    <div className="modal-container">
      <div className="error">
        <h2 className="modal-title">{title}</h2>
      </div>
      <div className="message">{message}</div>
      {buttons !== null && (
        <div className="actions">
          {buttons.SelBtn && (
            <a onClick={buttons.SelBtn.action} className="continue-btn">
              {loading === true ? (
                <div className="d-flex justify-content-center">
                  <div
                    className="loader m-0"
                    style={{
                      width: "1em",
                      height: "1em",
                      borderColor: "currentColor",
                      borderTopColor: "transparent",
                    }}
                  />
                  {buttons.SelBtn.text}
                </div>
              ) : (
                buttons.SelBtn.text
              )}
            </a>
          )}
          {buttons.formBtn && (
            <a onClick={buttons.formBtn.action} className="continue-btn active">
              {buttons.formBtn.text}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export const successModal = (message) => {
  return (
    <div className="modal-container success">
      <img src={SuccessIcon} alt="success" />
      <p>{message}</p>
    </div>
  );
};

export const subString = (chain, limit = 20) => {
  return chain != undefined && chain != "" && chain.length > limit
    ? `${chain.substring(0, limit)}...`
    : chain;
};

export const loadingModal = () => {
  return <Modal show={true}>{loadingHtml()}</Modal>;
};

export const escapedRegexCharacters = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const urlParam = (location, name) => {
  var results = new RegExp(name + "=([^&#]*)").exec(location);
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};

export const getConfigItem = (element) => {
  var item = element.split(".");
  var value = null;

  item.map((key) => {
    if (null === value) {
      value = cert;
    }

    value = value[key];
  });

  return value;
};

export const cleanIputText = (type, text) => {
  return type == "text" ? text.replace(/[^A-z0-9À-ž,.'#_-\s]/g, "") : text;
};

export const cleanIputTextNumber = (type, text) => {
  return type == "text" ? text.replace(/[^0-9]/g, "") : text;
};

export const diff_minutes = (dt2, dt1) => {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
};

export const formatUTCDate = (date) => {
  var formatDate = new Date(date);

  return `${formatDate.getUTCDate()}/${
    formatDate.getUTCMonth() + 1
  }/${formatDate.getUTCFullYear()}`;
};

export const getLogoutURL = (env) => {
  return cert.login[env].cams !== undefined
    ? `${cert.login[env].cams}aos/logout.bns?goto=${window.location.origin}/pages/landing`
    : "";
};

export const getStringDay = (day) => {
  var days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miercoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  return days[day];
};

export const getStringMonth = (month) => {
  const { t } = useTranslation();
  return `${t(`general.months.${month}`)}`;
};

export const formatDashDate = (date) => {
  var d = new Date(date);
  var month = d.getMonth() + 1;
  var monthDay = d.getDate();

  return `${d.getFullYear()}-${month < 10 ? `0${month}` : month}-${
    monthDay < 10 ? `0${monthDay}` : monthDay
  }`;
};

export const capitalize = (word) => {
  let lowerWord = word.toLowerCase();
  return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
};

export const formatResponse = ({ totalLines, totalLinesOk, details }) => {
  if (totalLines === totalLinesOk)
    return <p>La operación fue realizada con éxito.</p>;
  return (
    <>
      <p>Se presentaron los siguientes errores:</p>
      <ul>
        {details.map(({ message }, key) => (
          <li key={`res-${key}`}>{message}</li>
        ))}
      </ul>
    </>
  );
};

export const enableScroll = () => {
  if (typeof window !== "undefined") {
    const body = window.document.querySelector("body");
    body.style = {};
  }
};

export const isEmpty = (value) => !value.trim();

export const includeSpecialCharacters = (value) => /[^A-Za-z0-9 ]/.test(value);

export const invalidPhoneNumber = (value) => /[^0-9 +-]/.test(value);
export const invalidPhoneLastCharacter = (value) => {
  return isNaN(value.split("").join().slice(-1));
};

export const generateDocument = ({ mime_type, file_base64, filename }) => {
  let link = document.createElement("a");
  link.href = `data:${mime_type};base64,77u/${file_base64}`;
  link.download = `${filename}`;
  link.click();
};

export const customDecode = (jwt) => {
  return jwt
    ? JSON.parse(Buffer.from(jwt.split(".")[1], "base64").toString())
    : null;
};
